__turbopack_context__.v({
  "active": "veWmWG_active",
  "assetBottomLine": "veWmWG_assetBottomLine",
  "assetEtaButton": "veWmWG_assetEtaButton",
  "assetFooter": "veWmWG_assetFooter",
  "assetIcon": "veWmWG_assetIcon",
  "assetListItem": "veWmWG_assetListItem",
  "assetTopLine": "veWmWG_assetTopLine",
  "assetsAside": "veWmWG_assetsAside",
  "centerText": "veWmWG_centerText",
  "emptyItems": "veWmWG_emptyItems",
  "gone": "veWmWG_gone",
  "heading": "veWmWG_heading",
  "headingContainer": "veWmWG_headingContainer",
  "plateNumber": "veWmWG_plateNumber",
  "ptuPill": "veWmWG_ptuPill",
  "reference": "veWmWG_reference",
  "reportButton": "veWmWG_reportButton",
  "reportProcessing": "veWmWG_reportProcessing",
  "searchDivider": "veWmWG_searchDivider",
});
